var React = require('react');

function IconMeeting (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m15.878 11.114-4.899-3.977-.984.902c-1.332 1.217-2.848.39-3.337-.144a2.364 2.364 0 0 1 .144-3.337L9.486 2.1h-2.75c-.279 0-.544.112-.741.308L4.2 4.2H.525A.527.527 0 0 0 0 4.725v6.297c0 .288.236.525.525.525H4.8l2.97 2.687a2.1 2.1 0 0 0 2.953-.305l.007-.007.587.509a1.22 1.22 0 0 0 1.716-.177l1.03-1.267.178.145c.45.364 1.112.298 1.476-.155l.312-.384a1.052 1.052 0 0 0-.151-1.48ZM20.475 4.2H16.8l-1.792-1.792a1.048 1.048 0 0 0-.741-.308h-2.819a1.05 1.05 0 0 0-.709.276L7.514 5.329c-.003.003-.006.01-.01.013a1.302 1.302 0 0 0-.069 1.837c.315.345 1.149.71 1.841.089.003-.003.01-.003.013-.007l1.74-1.591.885-.81a.524.524 0 1 1 .709.774l-.856.784 4.777 3.878c.4.325.64.772.729 1.244h3.202a.527.527 0 0 0 .525-.525V4.722a.524.524 0 0 0-.525-.522Z"}));
}

IconMeeting.defaultProps = {"fill":"currentColor","viewBox":"0 0 21 17"};

module.exports = IconMeeting;

IconMeeting.default = IconMeeting;
